import {
  CUSTOMERS,
  GRID_ROWS_PER_PAGE,
  SWITCH_VALUE,
  CHECK_BOX_VALUE,
} from '../../../constants';

export const initialState = {
  editNoteData: [],
  displayDeleteAlert: false,
  customerBackToPrevious: [],
  selectedComponent: CUSTOMERS.radioButtonWithMultipleFilters, // variable for selected radio component
  selectedRowData: [], // variable for selected row data
  displayButtonValue: false, // variable for display button value
  globalCustomerNo: '',
  gCNumberLoader: false,
  customersGridTotalRecords: 0,
  customersGridResultsFound: true,
  billToCustomerCheckbox: {
    serializedFlag: CHECK_BOX_VALUE.no,
  },
  multipleInputsSelectedValues: {
    name: '',
    accountingGroup: '',
    parentPsCustomerCode: '',
    activeFlag: 'y',
    corporateCustomer: '',
    billtoCustomer: '',
    pageIndex: 0,
    recordCount: GRID_ROWS_PER_PAGE.customers,
  },
  dropDownValues: {
    activeFlag: CUSTOMERS.dropDownDefaultValueForYes,
    corporateCustomer: CUSTOMERS.dropDownDefaultValueForAny,
    billtoCustomer: CUSTOMERS.dropDownDefaultValueForAny,
  },
  selectedCustomerNameInputValue: {
    name: '',
    accountingGroup: '',
    parentPsCustomerCode: '',
    activeFlag: '',
    corporateCustomer: '',
    billtoCustomer: '',
    pageIndex: 0,
    recordCount: GRID_ROWS_PER_PAGE.customers,
  },

  isAccountingGroupsResultsFound: true,
  searchResult: [], // An array to store the search result
  searhResultForDataGrid: [], // An array to store the search result for data grid
  loading: false,
  inputError: null,
  selectedTabValue: 0,
  isExpanded: true,
  customerDetails: [],
  addressDetails: [],
  customerNameSearchTerm: '',
  showCustomernameSelectedValue: null,
  name: [],
  //Modals
  accountingGroupModal: {
    //Accounting Group
    openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
    accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
    gridAccountingRowSelectedData: [], // You can store the grid row selected data here
    gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
    accountingGroups: [], // You can store the accounting groups here
    accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
    accountingGroupSearchForm: {
      accountingGroupCode: '',
      isActive: SWITCH_VALUE.yes,
      isResellerGroup: SWITCH_VALUE.no,
    },
  },

  parentGlobalModal: {
    openParentGlobalCustomerNoModal: false, // You can store ParentGlobalCustomerNo modal open status here
    gridParentGlobalCustomerNoRowSelectedData: [], // You can store the grid row selected data here
    gridParentGlobalGridRowSelectedCount: 0,
    parentGlobalGridTotalRecords: 0,
    parentGlobalGridData: [],
    errorModal: null,
    customerNameSearchTerm: '',
    showCustomernameSelectedValue: null,
    name: [],
    isParentGlobalResultsFound: true,

    parentGlobalModalMultipleInputs: {
      name: '',
      accountingGroup: '',
      parentPsCustomerCode: '',
      activeFlag: 'y',
      corporateCustomer: '',
      billtoCustomer: '',
      pageIndex: 0,
      recordCount: GRID_ROWS_PER_PAGE.customers,
    },
    parentGlobalModalDropDownValues: {
      activeFlag: CUSTOMERS.dropDownDefaultValueForYes,
      corporateCustomer: CUSTOMERS.dropDownDefaultValueForAny,
      billtoCustomer: CUSTOMERS.dropDownDefaultValueForAny,
    },
  },
  customerHistoryTotalRecords: 0,
  customerHistory: [],
  customerHistoryDataFound: false,
  customerChildrenTotalRecords: 0,
  customerChildren: [],
  customerChildrenDataFound: false,

  customerNotesTotalRecords: 0,
  customerNotes: [],
  customerNotesDataFound: false,
  isCustomerNotesModalOpen: false,
  addCustomerNotes: {
    customer_Id: '',
    comment: '',
    customer_Note_Type_Id: '',
    last_Modified_Timestamp: new Date(),
    user_Id: 0,
    last_Modified_User_Id: 0,
    isEdit: false,
  },
  addedCustomerNote: '',
  deletedCustomerNote: '',
  orderNumber: [],
  siteID: [],
  salesOrdersCustomers: [],
  isSalesOrderDataFound: true,
  salesOrdersTotalCount: 0,
  loadCustSalesOrder: false,

  customerEntitlementSummaryTotalRecords: 0,
  customerEntitlementSummary: [],
  customerEntitlementSummaryDataFound: false,
  customerEntitlementSummaryEffectiveDate: '',
  customerEntitlementSummaryStatus: 1,

  customerSitesTotalRecords: 0,
  customerSites: [],
  customerSitesDataFound: false,
  customerSitesNameContains: '',
  customerNcrSitesIdContains: '',
  customerSitesActive: true,
  isNavigateToSiteModule: 0,

  //Customer Billing - Bill Notes
  customerBillNotes: [],
  customerBillNotesTotalRecords: 0,
  customerBillNotesDataFound: false,

  //Customer Billing - Bills
  customerBillsBill: [],
  customerBillsBillTotalRecords: 0,
  customerBillsBillDataFound: false,
  customerNotesLoading: false,
  isReset: false,
  customerInfoUpdated: null,
  customerInfoUpdateLoading: false,

  // sales orders tab
  searchTermOrderNo: '',
  selectedSearchTermOrderNo: null,
  searchTermSiteId: '',
  selectedSearchTermSiteId: null,
  //Billing - Bill Details
  billingViewLoading: false,
  billingViewData: [],
  billingViewCount: 0,
  loadingAccountingGroup: false,
  loadingCustomerEntitlementSummaryEmail: false,
  customerEntitlementSummaryMailResponse: null,
};
